import { render, staticRenderFns } from "./TenantAddLandlordPm.vue?vue&type=template&id=35f25a6d&scoped=true&"
import script from "./TenantAddLandlordPm.vue?vue&type=script&lang=js&"
export * from "./TenantAddLandlordPm.vue?vue&type=script&lang=js&"
import style0 from "./TenantAddLandlordPm.vue?vue&type=style&index=0&id=35f25a6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f25a6d",
  null
  
)

export default component.exports